// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"017c68fd","467":"dd332795","590":"6e15f627","682":"408a280e","858":"077d9676","884":"7892b5b4","993":"4ee3f856"}[chunkId] + ".chunk.js";
};